document.addEventListener('DOMContentLoaded', function () {
  const tabs = document.querySelectorAll('.nav-link');
  const contents = document.querySelectorAll('.tab-content');
  const swipers = []; // Array to hold Swiper instances

  function deactivateAllTabs() {
    tabs.forEach(tab => tab.classList.remove('active'));
    contents.forEach(content => content.style.display = 'none');
  }

  function activateTab(tab) {
    const tabId = tab.getAttribute('data-tab');
    const content = document.getElementById(tabId);

    tab.classList.add('active');
    content.style.display = 'block';

    const swiperContainer = content.querySelector('.product-slides');

    const updateArrowVisibility = () => {
      // Check visibility for all swipers
      let arrowsVisible = true; // Assume arrows should be visible

      swipers.forEach(swiper => {
        const totalSlides = swiper.slides.length;
        const slidesPerView = swiper.params.slidesPerView;

        // If any swiper has fewer slides than slidesPerView, hide arrows
        if (totalSlides <= slidesPerView) {
          arrowsVisible = false;
        }
      });

      const nextButton = document.querySelector('.collection-swiper-button-next');
      const prevButton = document.querySelector('.collection-swiper-button-prev');

      if (arrowsVisible) {
        nextButton.style.display = 'block';
        prevButton.style.display = 'block';
      } else {
        nextButton.style.display = 'none';
        prevButton.style.display = 'none';
      }
    };

    if (swiperContainer.swiper) {
      swiperContainer.swiper.update();
    } else {
      const swiperInstance = new Swiper(swiperContainer, {
        loop: true,
        speed: 1000,
        slidesPerView: 1, 
        spaceBetween: 10,
        navigation: {
          nextEl: '.collection-swiper-button-next',
          prevEl: '.collection-swiper-button-prev',
        },
        breakpoints: {
          0: {
            slidesPerView: 1.5,
            centeredSlides: true,
            spaceBetween: 20,
          },
          640: {
            slidesPerView: 2,
            spaceBetween: 20,
            centeredSlides: false,
          },
          769: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
          1025: {
            slidesPerView: 4,
            spaceBetween: 30,
            loop: true,
          },
        }
      });

      swipers.push(swiperInstance); // Store the Swiper instance
    }

    updateArrowVisibility(); // Check visibility after activating the tab
  }

  tabs.forEach(tab => {
    tab.addEventListener('click', function () {
      deactivateAllTabs();
      activateTab(this);
    });
  });

  if (tabs.length > 0) {
    deactivateAllTabs();
    activateTab(tabs[0]);
  }
});
